import { Image } from 'antd';
import NoImage from 'components/etc/NoImage';
import { Edit2, Trash } from 'iconsax-react';
import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import { IVisible } from '../AssetsPage';
import { useCookies } from 'react-cookie';
import ActionButton from 'components/table/ActionButton';
import { useHover } from '@uidotdev/usehooks';
import ItemBox from './ItemBox';

interface IProps {
  data: any;
  visible: IVisible;
  setSelectedData: React.Dispatch<any>;
  selectedData: any;
  setVisible: React.Dispatch<React.SetStateAction<IVisible>>;
  handleClickDeleteModal: (record: any) => void;
}
const GridList: React.FC<IProps> = ({
  data,
  visible,
  setSelectedData,
  selectedData,
  setVisible,
  handleClickDeleteModal,
}) => {
  return (
    <Wrapper>
      {data?.map((el, i) => {
        return (
          <ItemBox
            key={i}
            el={el}
            visible={visible}
            setSelectedData={setSelectedData}
            selectedData={selectedData}
            setVisible={setVisible}
            handleClickDeleteModal={handleClickDeleteModal}
          />
        );
      })}
    </Wrapper>
  );
};

export default GridList;

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 24px;
  .text-margin {
    margin-top: 8px;
  }

  @media (max-width: 1650px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (max-width: 1280px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 720px) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
`;
